<template>
  <v-app>
    <div id="offers">
      <div id="offers-banner">
        <section class="banner">
          <v-parallax height="990" src="@/assets/images/banner.webp">
              <v-row justify="center">
                <v-col class="text-center" cols="12" sm="10" md="10" lg="8">
                  <div>
                    <v-row justify="center">
                      <v-col cols="12" sm="11" md="9" lg="11" class="py-0">
                        <h1 class="banner__title">Ofertas de Trabajo</h1>
                      </v-col>
                      <v-col cols="11" sm="9" md="9" lg="9">
                        <p class="banner__text">Revisa nuestras ofertas y encuentra un trabajo con sentido.
                        Trabajar en organizaciones con propósito tiene una mayor retribución.
                        No solo recibes un sueldo a fin de mes, además contribuyes a generar impacto positivo.
                        </p>
                      </v-col>
                    </v-row>
                    <div class="main-btn">
                      <v-row justify="center">
                        <v-col cols="10" sm="10" md="10" lg="8">
                          <v-text-field
                            label="Buscar"
                            v-model="searchText"
                            @input="searchKeyInput()"
                            @keyup.enter.native="searchOffer()"
                            prepend-inner-icon="mdi-magnify"
                            color="info"
                            class="btn-search"
                            solo
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <OffersList ref="offersList"/>
          </v-parallax>
        </section>
      </div>
      <FAQ />
    </div>
  </v-app>
</template>

<script>
import OffersList from "@/components/OffersList";
import FAQ from "@/components/FAQ";
import { meta } from "@/libs/mixins";

export default {
    data() {
        return {
            timerId: null,
            searchText: "",
            searchedText: ""
        };
    },

    components: { OffersList, FAQ },

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Ofertas de trabajo",
        });
    }, 

    created() {
        if (this.filter) {
            this.searchText = this.filter;
            this.searchedText = "";
            this.searchKeyInput();
        }
    },

    methods: {
        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.searchOffer();
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
        searchOffer() {
            if (this.searchedText != this.searchText) {
                this.$refs.offersList.update(this.searchText.replace(/ /g, ","));
                this.searchedText = this.searchText;
            }
        },
        cleartext() {
            /// TODO agregar icono de borrado
            this.searchedText = this.searchText = "";
        }
    }
};
</script>
